import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/reports/general-details`

export default async (queryParams = {}) => {
  const { data } = await http.get(`${api}`, { params: { ...queryParams } }).catch(err => console.error(err.message))
  return data
}
